<template>
  <a-modal
    :title="$t('base.settingCompanyName')"
    :width="500"
    :visible.sync="userVisible"
    @cancel="closeSettingUserNameModal"
    :bodyStyle="{ paddingBottom:0, paddingTop: '20px'}"
    @ok="handleOkAddUser"
  >
    <div class="login-form-wrapper">
      <a-form-model :model="form" :rules="rules" ref="loginForm" layout="vertical" class="login-form">
        <a-form-model-item prop="companyName" :label="$t('base.originalCompanyName')">
          <a-input v-model="form.companyName" autocomplete="new-password" hide-button disabled></a-input>
        </a-form-model-item>
        <a-form-model-item prop="newCompanyName" :label="$t('base.newCompanyName')">
          <a-select
            v-model="form.newCompanyName"
            show-search
            size="large"
            :options="companies"
            @change="chooseCompany"
            :filter-option="filterCompanies"
          >
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="otherCompanyName" label="公司完整名称" v-if="form.companyCode === 'other'">
          <a-input v-model="form.otherCompanyName" :disabled="loading"></a-input>
        </a-form-model-item>
      </a-form-model></div
  ></a-modal>
</template>

<script>
import { searchCompany, getUserUpdate } from '@/api/user'

export default {
  props: {
    userId: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      userVisible: true,
      newValue: null,
      form: {
        companyName: this.company,
        newCompanyName: '',
        otherCompanyName: '',
        companyCode: '',
      },
      userList: [], // 用户列表
      countdown: 0,
      loading: false,
      isSendCode: false, //是否发送过验证码
      companies: [
        { label: '其他', value: '其他', code: 'other' },
        { label: '中国建筑集团有限公司', value: '中国建筑集团有限公司', code: '1' },
        { label: '中国铁建股份有限公司', value: '中国铁建股份有限公司', code: '2' },
        { label: '中国中铁股份有限公司', value: '中国中铁股份有限公司', code: '3' },
      ],
      options: [
        {
          value: '选项1',
          label: '黄金糕',
        },
        {
          value: '选项2',
          label: '双皮奶',
        },
        {
          value: '选项3',
          label: '蚵仔煎',
        },
        {
          value: '选项4',
          label: '龙须面',
        },
        {
          value: '选项5',
          label: '北京烤鸭',
        },
      ],
      fetching: false,
      lastFetchId: 0,
      secret: '', // 加密密钥
      currentUserInfo: {}, // 账户信息
      hasUser: false, // 是否已经注册过
    }
  },
  computed: {
    rules() {
      return {
        newCompanyName: [{ required: true, message: this.$t('base.pleaseInputCompany'), trigger: 'change' }],
        otherCompanyName: [{ required: true, message: this.$t('base.pleaseInputCompanyName'), trigger: 'blur' }],
      }
    }
  },

  async mounted() {
    // select的placeholder 属性失效问题
    // document.getElementsByClassName('ant-select-selection__placeholder')[0].style.display = 'block'
    this.getCompanyList()
  },
  methods: {
    // 选择公司
    chooseCompany(value) {
      this.companies.forEach((item) => {
        if (item.value === value) {
          this.form.companyCode = item.code
        }
      })
    },
    // 确认
    async handleOkAddUser() {
      try {
        // 表单验证
        await this.$refs.loginForm.validate()
        const data = {
          company: this.form.newCompanyName,
          companyCode: this.form.companyCode,
          account: this.userId,
        }
        // 调用验证码登录接口
        const loginRes = await getUserUpdate(data)
        if (loginRes.code === 200) {
          this.$message.success('修改成功！')
          this.$emit('refreshDetail')
        } else {
          this.$message.error(loginRes.message || '修改失败，请重试！')
        }
      } catch (error) {
        if (error.message) {
          // this.$message.error(error.message)
        }
      } finally {
        this.loading = false
      }
    },
    // 关闭
    closeSettingUserNameModal() {
      this.$emit('closeSettingPhoneModal')
    },
    // 过滤公司名称
    filterCompanies(input, option) {
      return option.data.props.value.indexOf(input) >= 0
    },

    // 获取公司列表
    async getCompanyList() {
      try {
        const res = await searchCompany({ keyWord: '' })
        console.log(res, '获取公司列表获取公司列表')
        this.companies = [{ label: '其他', value: '其他', code: 'other' }]
        res.data.forEach((item) => {
          this.companies.push({
            label: item.companyName,
            value: item.companyName,
            code: item.companyCode,
          })
        })
      } catch (error) {
        console.error('Get company list error:', error)
        this.$message.error('获取公司列表失败，请重试')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.login-form {
  font-size: 18px;

  .incocss {
    font-size: 18px;
    margin-right: 3px;
  }

  &-wrapper {
    width: 360px;
    color: #fff;
  }

  /deep/.ant-input-affix-wrapper {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus,
    &-focused {
      box-shadow: none;
    }

    .ant-input {
      background-color: transparent;
      color: #fff;
    }
    .anticon {
      color: #a2a5ae;
    }
  }

  /deep/.ant-input-password {
    background-color: #222222;
    border-radius: 8px;

    .ant-input {
      background-color: transparent;
      color: #fff;
    }

    .anticon {
      color: #a2a5ae;
    }
  }

  /deep/.ant-input {
    height: 40px;
    background-color: #222222;
    border-radius: 8px;
    color: #fff;
    &:focus {
      box-shadow: none;
    }
    &:hover {
      background-color: #222222;
    }
  }

  /deep/.ant-select {
    .ant-select-selector {
      background-color: #222222 !important;
      border-radius: 8px !important;

      .ant-select-selection-item {
        color: #ffffff !important;
      }
    }

    .ant-select-arrow {
      color: #a2a5ae;
    }
  }
  /deep/.ant-select-lg .ant-select-selection--single {
    height: 40px;
    background-color: #222222;
    color: #fff;
    &:hover {
      background-color: #222222;
    }
  }

  /deep/.ant-select-dropdown {
    background-color: #222222;

    /deep/.ant-select-item {
      color: #ffffff;

      &-option-active,
      &-option-selected {
        background-color: #333333;
      }
    }
    /deep/.ant-select-item-option {
      background-color: #222222;
      color: #ffffff;
    }
  }
}
</style>
